import { useTranslation } from "react-i18next";
import React from "react";
import styled from "styled-components";

import { AtiraImage } from "../../../../../components/Image";
import { Text } from "../../../../../components/Text";
import { ConversationMessage } from "../../../../../model/integration/dto/meta/MetaConversationMessage";
import { Rounded } from "../../../../../theme/Rounded";
import { Spacing } from "../../../../../theme/Spacing";
import { getMediaUrl } from "../../../../../utils/Media";
import { WAMediaRetentionInfo } from "./WAMediaRetentionInfo";
import { WAMediaUnavailable } from "./WAMediaUnavailable";
import { isMediaPending } from "./media-state";

const Frame = styled.div`
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: ${Rounded.md};
  line-height: 0;
  max-width: 17rem;

  img {
    width: 100%;
    height: auto;
    max-height: 20rem;
    object-fit: cover;
    cursor: zoom-in;
  }
`;

const Caption = styled(Text)`
  margin-top: ${Spacing.xs};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  unicode-bidi: plaintext;
  text-align: start;
`;

type Props = {
  message: ConversationMessage;
};

export const WAMessageImage: React.FC<Props> = ({ message }) => {
  const { mediaId, image, localPreviewUrl } = message;
  const { t } = useTranslation();

  // While our own copy is still uploading the only thing that can be shown is
  // the file the user picked, straight out of the browser
  if (!mediaId && !localPreviewUrl) {
    return (
      <WAMediaUnavailable
        label={t("common.whatsapp.image")}
        expired={Boolean(message.mediaExpiredAt)}
        pending={isMediaPending(message)}
      />
    );
  }

  return (
    <div>
      <Frame>
        <AtiraImage
          preview
          src={localPreviewUrl || getMediaUrl(mediaId!)}
          alt={image?.caption || "WhatsApp image"}
        />

        {mediaId ? (
          <WAMediaRetentionInfo createdAt={message.createdAt} />
        ) : null}
      </Frame>

      {image?.caption ? <Caption fontSize="s">{image.caption}</Caption> : null}
    </div>
  );
};
